import { DVSClientClass, getDefaultEdgeUrl } from './dvsClient';

export { DVSClientClass, getDefaultEdgeUrl };

export * from './types';

export default new DVSClientClass();
